import { Attributes, Rules, Validation, ValueObject } from '@singularsystems/neo-core';
import { Display } from '@singularsystems/neo-core/dist/Model/Decorators';
import { FieldSetting } from './FieldSetting';
import { MandatoryAndVisibleSetting, VisibleSetting } from './FieldSetting.enum';
import IInvestmentFields from './IInvestmentFields';

export default class IssuerInvestmentFieldConfig extends ValueObject implements IInvestmentFields {

    constructor() {
        super();
        this.makeObservable();
    }

    // Details tab

    public investmentName: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public investmentCode: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("ISIN")
    public isin: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Asset Type")
    public assetTypeId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public certificateNumber: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public distinctiveNumber: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public signingDate: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public ledgerCode: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public businessUnitNo: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @FieldSetting(String)
    @Rules.StringLength(50)
    public businessUnitNoLabel: string = "";

    public subscriptionDate: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public migrationDate: VisibleSetting = VisibleSetting.Visible;

    @Display("Profit Centre")
    public branchId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public security: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public fixedCostOfFunds: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public liquidityPremium: VisibleSetting = VisibleSetting.Visible;

    @Display("Notice Period")
    public noticePeriodId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public originalBalance: VisibleSetting = VisibleSetting.Visible;

    @Display("PSD Asset")
    @FieldSetting(VisibleSetting)
    public psdAsset: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public liquidityLadder: VisibleSetting = VisibleSetting.Visible;

    @Display("LP Determination Date")
    public lpDeterminationDate: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("NCC")
    @FieldSetting(VisibleSetting)
    public ncc: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public otherCost: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(MandatoryAndVisibleSetting)
    public distributionTypeId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    // Investment Tab

    @Display("Initial End Date")
    public initialEndDate: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Payment Date Convention")
    @FieldSetting(VisibleSetting)
    public paymentDateConvention: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public paymentDateOffset: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public completeDividendCycle: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public reinvestDividends: VisibleSetting = VisibleSetting.Visible;

    @Display("Compounding Cycle")
    public compoundingCycleId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public compoundOnDividend: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public compoundOnRateChange: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public endOfMonthReporting: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public rateGrossedUp: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public equityUpside: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public capacityWarehouse: VisibleSetting = VisibleSetting.Visible;

    @Display("GL Account Type")
    @FieldSetting(VisibleSetting)
    public glAccountType: VisibleSetting = VisibleSetting.Visible;

    @Display("SAP GL Code")
    @FieldSetting(VisibleSetting)
    public sapglCode: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public qualifyingPurpose: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public parValuePerShare: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public premiumPerShare: VisibleSetting = VisibleSetting.Visible;

    public productTypeId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Issuer Investment Fields Config";
    }
}